import { render } from "./D_commonFormList.vue?vue&type=template&id=283ae9fc"
import script from "./D_commonFormList.vue?vue&type=script&lang=js"
export * from "./D_commonFormList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__